export default __webpack_public_path__ + "static/media/BackgroundIntroduction.4f51badb.png";